import { DataSourcesTypes } from "@common/types/data-source-types";
import apiUseCases from "@src/cloud-connect/api";
import { parseAxiosApiError } from "@src/cloud-connect/utils/parse-axios-api-error";
import store from "@src/reducers/store";

export interface GetSourcesBySourceNamespaceResult {
  success: boolean;
  data?: DataSourcesTypes;
  error?: string;
}

export const getSourcesBySourceNamespaceUseCase = async (
  sourceNamespace: string,
): Promise<GetSourcesBySourceNamespaceResult> => {
  try {
    const namespace = store.getState().yourSlice.authContext.customerNamespace;
    const response = await apiUseCases.getSourcesBySourceNamespace(
      namespace,
      sourceNamespace,
    );

    return {
      success: true,
      data: response.data_sources,
    };
  } catch (error) {
    return {
      success: false,
      error: parseAxiosApiError(error, "Failed to fetch sources").message,
    };
  }
};
